import OptionsForm from './OptionsForm';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react-lite';
import { Option } from 'owa-options-core';
import * as React from 'react';

const styles = require('./OptionsFull.scss');

export interface OptionsPaneProps {
    options: Option[];
}

export default observer(function OptionsPane(props: OptionsPaneProps) {
    const optionFormRefs = React.useRef<Record<string, HTMLDivElement>>({});
    const settingsForm = React.useRef<HTMLDivElement>();

    React.useEffect(() => {
        let selectedOption: HTMLDivElement;
        let currentOptionKey = getStore().currentOptionKey;

        if (currentOptionKey && (selectedOption = optionFormRefs.current[currentOptionKey])) {
            settingsForm.current.scrollTop = selectedOption.offsetTop;
        } else {
            settingsForm.current.scrollTop = 0;
        }
    }, [getStore().currentOptionKey]);

    return (
        <div ref={settingsForm} className={styles.settingsForm}>
            {props.options.map(option => (
                <OptionsForm
                    option={option}
                    key={option.key}
                    ref={ref => (optionFormRefs.current[option.key] = ref)}
                />
            ))}
        </div>
    );
});
